import { Static, Type } from "@sinclair/typebox";
import { ApiErrorResponse } from "@whatslly/types/ApiErrorResponse";
import { User } from "./User";
import { LayoutFieldsSetup } from "./LayoutFieldsSetupType";
import { DLPPolicy } from "./dlp/DLPPolicy";
import { DLPSettings } from "./dlp/DLPSettings";
import { UrlPoliciesSettings } from "@whatslly/types/integrations/UrlPoliciesSettings";
import { SurveillanceSettings } from "./surveillance/SurveillancePolicy";

export const AUTH_RESPONSE_ERROR_TYPES = {
  SALESFORCE_ERROR: "SALESFORCE_ERROR",
  UNKNOWN_ISSUE: "UNKNOWN_ISSUE",
  USER_IS_INACTIVE: "USER_IS_INACTIVE",
  USER_NOT_INVITED: "USER_NOT_INVITED",
  PHONE_NOT_MATCH: "PHONE_NOT_MATCH",
  USER_WITHOUT_PERMISSION: "USER_WITHOUT_PERMISSION",
  USER_NOT_SUPPORTED: "USER_NOT_SUPPORTED",
  API_CURRENTLY_DISABLED: "API_CURRENTLY_DISABLED",
  APEX_REST_SERVICES_DISABLED: "APEX_REST_SERVICES_DISABLED",
} as const;

export const AuthResponseSuccess = Type.Object({
  success: Type.Literal(true),
  user: User,
  urlPoliciesSettings: UrlPoliciesSettings,
  dlpSettings: DLPSettings,
  surveillanceSettings: Type.Optional(SurveillanceSettings),
  dlpRules: Type.Array(DLPPolicy), // for backward compatibility. can remove in a few versions of desktop & extension
  fields: Type.Optional(LayoutFieldsSetup),
  wPod: Type.Optional(Type.String()),
  goto: Type.Optional(Type.String()),
  etoken: Type.String(),
});

export const AuthResponse = Type.Union([ApiErrorResponse, AuthResponseSuccess]);

export type AuthResponseType = Static<typeof AuthResponse>;
